import { configureStore } from '@reduxjs/toolkit';
import customerSlice from '../slices/customerSlice';
import creditSlice  from '../slices/creditSlice';
import citySlice  from '../slices/citySlice';
import dataTypeSlice  from '../slices/dataTypeSlice';
import traceabilitySlice  from '../slices/traceabilitySlice';
import userSlice  from '../slices/userSlice.js';
import usersSlice  from '../slices/usersDataSlice.js';
import officesSlice  from '../slices/officesSlice.js';
import typeUserSlice  from '../slices/typeUserSlice.js';
import campaignSlice  from '../slices/campaignSlice.js';
import customerGroupSlice  from '../slices/customerGroupSlice.js';
import customerTypeSlice  from '../slices/customerTypeSlice.js';
import disbursementOfficeSlice  from '../slices/disbursementOfficeSlice.js';
import panelStatsSlice from '../slices/panelStatsSlice.js';

export const store = configureStore({
  reducer: {
    customers: customerSlice,
    credits:  creditSlice,
    cities:  citySlice,
    dataTypes:  dataTypeSlice,
    traceability:  traceabilitySlice,
    user:  userSlice,
    users:  usersSlice,
    offices:  officesSlice,
    typeUser:  typeUserSlice,
    campaign:  campaignSlice,
    customerGroup: customerGroupSlice,
    customerType: customerTypeSlice,
    disbursementOffice: disbursementOfficeSlice,
    panelStats: panelStatsSlice,
  },
});